import { create } from "zustand";
import { getToken, setToken, clearToken } from "../shared/tokenStorage";

/**
 * Zustand store for managing authentication state (token).
 *
 * This store handles the "client state" part of authentication.
 * It syncs with localStorage via the tokenStorage utility.
 *
 * @example
 * const token = useAuthStore((state) => state.token);
 * const setToken = useAuthStore((state) => state.setToken);
 */
export const useAuthStore = create((set) => ({
  token: getToken(),

  setToken: (token) => {
    setToken(token); // Persist to localStorage
    set({ token }); // Update state
  },

  clearToken: () => {
    clearToken(); // Clear from localStorage
    set({ token: null }); // Update state
  },
}));
